import React from 'react';
import AppPage from '../common/AppPage';
import EquipmentTrainerHeader from './EquipmentTrainerHeader';
import EquipmentTrainerMain from './EquipmentTrainerMain';

function EquipmentTrainerPage() {
  
  return (
    <AppPage pageClass="skill-trainer-page">
      <div className="skill-trainer">
        <h5>WoTMud Equipment Trainer</h5>
        <EquipmentTrainerHeader />
        <EquipmentTrainerMain />
      </div>
    </AppPage>
  );
}

export default EquipmentTrainerPage;